import { fontSize, fontWeight, lineHeight } from "../../../../../constants/typography";
import styled from 'styled-components';
import { colors } from "../../../constants";
export var Heading = styled.h3.withConfig({
  componentId: "sc-1f8la8z-0"
})(["text-transform:uppercase;font-size:", ";line-height:", ";margin:0 0 32px;font-weight:", ";color:", ";"], fontSize.small, lineHeight.large, fontWeight.bold, function (_ref) {
  var palette = _ref.palette;
  return colors[palette];
});